import React from 'react'
import { render } from 'react-dom'

const renderComponent = Component => (props, element) =>
  render(<Component {...props} />, element)

export default renderComponent



// WEBPACK FOOTER //
// ../src/utils/renderComponent.js